import { Component } from 'preact'
import fetch from 'unfetch'

class Fetch extends Component {
  props = {
    transform: i => i,
    onload: () => {},
  }
  state = {
    loading: true,
    error: null,
    data: null
  }

  doFetch () {
    this.setState({ loading: true })
    fetch(this.props.src)
      .then(r => r.json())
      .then(j => this.props.transform(j))
      .then(data => {
        if (this.willUnmount === true) {
          return
        }

        this.setState({ data, error: null, loading: false }, this.props.onload)
      })
      .catch(error => this.setState({ error }))
  }

  componentDidMount () {
    this.doFetch()
  }

  componentDidUpdate (prevProps) {
    if (this.props.src !== prevProps.src) {
      this.doFetch()
    }
  }

  componentWillUnmount () {
    this.willUnmount = true
  }

  render ({ children }, state) {
    return children[0](state)
  }
}

export default Fetch
